import React, { useEffect, useState } from "react";
import MyInput from "../../MyComp/UI/form/MyInput";
import Status from "../../MyComp/UI/form/Status";
import MyButton from "../../MyComp/UI/form/MyButton";
import { useForm } from "react-hook-form";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { Badge, Form, Label } from "reactstrap";
import { createCategoryAPI, listCategoryAPI, updateCategoryAPI } from "../../api/master/indes";
import { decrypt, ValidateImg } from "../../utils/Utils";
import { toast } from "react-toastify";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import Select from "react-select";
import { BASE_URL_IMG } from "../../assets/constants";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import useLogout from "../../hooks/useLogout";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import MySelect from "../../MyComp/UI/form/MySelect";

const Category = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      addSub: false,
      data: [],
      category_image: null,
      category_img: null,
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const data = watch("data");
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [column, setColumn] = useState([
    {
      name: "Image",
      selector: (row) => (
        <div>
          {/* <img style={{ width: "50px" }} src={`${BASE_URL_IMG}` + row.image} /> */}
          <UserAvatarCell
            row={row}
            name={row?.name}
            handleImageOpenPreview={handleImageOpenPreview}
            image={`${BASE_URL_IMG}${row.image}`}
          />
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,
    },

    {
      name: "Order",
      selector: (row) => row?.order,
      sortable: true,
      wrap: true,
    },
    {
      name: "Discount Type",
      selector: (row) => row?.discount_type,
      sortable: true,
      wrap: true,
    },
    {
      name: "Discount",
      selector: (row) => row?.discount,
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status ? "success" : "danger"}`}>{row.status ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,

      // width: "90px",
    },
    {
      name: "Action",
      wrap: true,
      // width: "120px",
      cell: (row) => (
        <div>
          <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
            {" "}
            <Icon name="edit" />
          </Button>
          {/* <Button
            outline
            color="primary"
            size="xs"
            onClick={() => handleSubCategoryClick(row)}
            data-toggle="tooltip"
            data-placement="top"
            title="Add new Sub Menu"
          >
            <Icon name="plus"></Icon>
          </Button> */}
          {/* <Button outline color={`danger`} size={`xs`} onClick={() => handleDelete(row)}>
              {" "}
              <Icon name="trash"></Icon>
            </Button> */}
        </div>
      ),
    },
  ]);
  useEffect(() => {
    getCategoryList();
  }, []);
  const getCategoryList = () => {
    listCategoryAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("data", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("data", []);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const onFormSubmit = (data) => {
    const formData = new FormData();

    formData.append("order", watch("order"));
    formData.append("status", watch("status")?.value);
    formData.append("discount", watch("discount") || 0);
    formData.append("discount_type", watch("discount_type")?.value || "percentage");
    const i = watch("category_img");
    if (data?.category_img) {
      formData.append("img", i);
    }
    if (watch("addSub")) {
      formData.append("parent_id", data?.sub_category ? data?.sub_category?.value : watch("selectedRow")?.id);
      formData.append("name", watch("subCategory"));
    } else {
      formData.append("name", watch("category"));
    }
    if (mode == "Edit") {
      formData.append("id", watch("selectedRow")?.id);
    }

    if (mode == "Add") {
      createCategoryAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getCategoryList();
            setIsOpen(false);
            setValue("isLoading", false);
            resetF();
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
    if (mode == "Edit") {
      updateCategoryAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getCategoryList();
            setIsOpen(false);
            setValue("isLoading", false);
            resetF();
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setValue("addSub", false);
    setMode("Edit");
    setValue("category", row?.name);
    const imageUrl = `${BASE_URL_IMG}${row.image}`;
    setValue("category_image", imageUrl); //image_url value
    setValue("order", row?.order);
    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: row.status,
    });
    setValue("discount", row?.discount);

    setValue("discount_type", {
      label: row?.discount_type,
      value: row?.discount_type,
    });
  };
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const confirmStatusChange = (data) => {
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    setValue("isLoading", true);
    const formObject = {
      id: watch("selectedRow").id,
      status: updatedStatus,
    };
    updateCategoryAPI(formObject)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getCategoryList();
          setIsOpen(false);
          setValue("isLoading", false);
          setShowModal(false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };

  const handleSubCategoryClick = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(true);
    setMode("Add");
    setValue("addSub", true);
    setValue("selectedRow", row);
    setIsOpen(true);
    setValue("category", row?.name);
    setValue("order", "");
    setValue("status", "");
    setValue("subCategory", "");
    setValue(
      "subCategoryList",
      row?.subcategory?.map((item) => ({
        value: item.id,
        label: item.name,
      }))
    );
    console.log(row);
  };

  const handleSubCategoryChange = (sel) => { };
  const resetF = () => {
    setValue("category_image", null);
    setValue("category", "");
    setValue("status", null);
    setValue("addSub", false);
    setValue("category_img", null);
    setValue("order", "");
    setValue("discount_type", "");
    setValue("discount", "");
    setValue("addSub", false);
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  return (
    <>
      <Head title={"Category | Master"} />
      <Content>
        <BlockHead size={`sm`} className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Category"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block className="pt-0">
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="4" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Category"}
                      name={"category"}
                      placeholder={"Enter category name"}
                      required
                      min={2}
                      max={50}
                      disabled={watch("addSub")}
                    />
                  </Col>
                  {watch("addSub") ? (
                    <>
                      <Col md="4">
                        <div className="form-group mt-2">
                          <Label className="from-label" htmlFor="sub_category">
                            Sub Category
                          </Label>
                          <div className="form-control-wrap">
                            <Select
                              className=""
                              id="sub_category"
                              options={watch("subCategoryList")}
                              {...register("sub_category", {})}
                              onChange={(e) => handleSubCategoryChange(e)}
                              value={watch("sub_category")}
                            />
                            {errors.sub_category && (
                              <span
                                className="invalid"
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors?.sub_category?.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md="4" className={``}>
                        <MyInput
                          register={register}
                          watch={watch}
                          setValue={setValue}
                          trigger={trigger}
                          errors={errors}
                          title={"Sub Category"}
                          name={"subCategory"}
                          placeholder={"Enter sub category name"}
                          required
                          min={2}
                          max={50}
                        />
                      </Col>
                    </>
                  ) : null}
                  <Col md="4">
                    <ImageUpload
                      id="category_image"
                      watch={watch}
                      setError={setError}
                      label={"Upload Category Image"}
                      errors={errors}
                      register={register}
                      trigger={trigger}
                      clearErrors={clearErrors}
                      image={"category_img"}
                      image_url={"category_image"}
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      getValues={getValues}
                    />
                  </Col>
                  {/* Order */}

                  <Col md="4" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Order"}
                      name={"order"}
                      placeholder={"Enter category order"}
                      required
                      min={1}
                      max={2}
                    />
                  </Col>
                  <Col md="4" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Discount Type"}
                      name={"discount_type"}
                      placeholder={"discount type"}
                      required
                      options={[
                        { value: "percentage", label: "percentage" },
                        { value: "fixed", label: "fixed" },
                      ]}
                    />

                  </Col>
                  <Col md="4" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Discount"}
                      name={"discount"}
                      placeholder={"Enter discount"}
                      required

                    />
                  </Col>

                  <Col md={`4`}>
                    <Status
                      register={register}
                      watch={watch}
                      title={"Status"}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Col md="2" className={``}>
                  <div className="form-group" style={{ marginTop: "31px" }}>
                    <MyButton isLoading={isLoading} mode={mode} />
                  </div>
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          <MyDataTable data={data || []} columns={column} title={"Category List"} isLoading={isLoading} />
        </Block>
      </Content>
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default Category;
